import { Market, PrivacySettingToggles } from '../types/market';
import { it as adConfig } from '../ads';

const market: Market = {
  countryCode: 'it',
  active: false,
  permanentRedirect: true,
  sitename: 'Pagomeno',
  superSearchEndpoint: 'https://search.pagomeno.it/rfe',
  redirectHosts: ['m.pagomeno.it', 'www.pagomeno.it'],
  useClassicUrls: true,
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  classicProxy: {
    host: 'int-classic-it.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['it'],
  locale: 'it-it',
  sites: {
    production: 'https://pagomeno.it',
    classic: 'https://classic.pagomeno.it',
    analytics: 'https://classic.pagomeno.it/analytics/store',
    forum: undefined,
    brands: undefined,
    mobile: 'https://m.pagomeno.it',
  },
  api: {
    default: 'http://int-api-it.prisjakt.io:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
    previousCampaignDates: {
      '2': '2018-11-23', // BF
      '16': '2019-11-11', // Singles day
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'it',
  timezone: 'Europe/Rome',
  currencyCode: 'EUR',
  url: {
    campaigns: '/eventi',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.pagomeno.it',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/pagomeno/',
    },
    facebook: {
      link: 'https://www.facebook.com/pagomeno',
      clientID: '307178032990062',
      clientSecret: '935fb83d41335a2b33d791a2dc3487d6',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      link: 'https://twitter.com/Pagomeno',
      consumerKey: 'Serraq2AKu2hxEqgwlTHXOqGW',
      consumerSecret: 'DS99yUroUyojkt0eg3dCMVjuCeVCeO7n6E6opqbKQtgT8WhWQm',
      callbackURL: `/_internal/auth/twitter/callback`,
    },
  },
  email: {
    noreply: 'noreply@pagomeno.it',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    images: 'https://pricespy-75b8.kxcdn.com/',
  },
  routes: {
    giftGuide: {
      // HACK: Must include all current running giftGuides, hardcoded
      path: '/eventi/:name(regali-di-natale)/:list?',
    },
    themes: {
      path: '/eventi',
    },
    campaign: {
      path: '/eventi/:name',
    },
    productCompare: {
      path: '/compara/prodotti/:productIds?',
    },
    editorialContentListing: {
      path: '/articoli',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Migliori offerte sotto i 400 €',
      path: '?price=0-400&sort=rank%7Cdesc',
    },
    {
      title: 'Videogiochi',
      path: '?sort=rank%7Cdesc&category=401%7C1707',
    },
    {
      title: 'Smartphone',
      path: '?sort=rank%7Cdesc&category=103',
    },
    {
      title: 'Offerte per la casa',
      path:
        '?category=532%7C559%7C515%7C513%7C520%7C1645%7C107%7C1046%7C576%7C523%7C524%7C528',
    },
    {
      title: 'Scarpe sportive',
      path: '?category=1518',
    },
  ],

  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
    articles: 'articles',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: '6QsclJuWz8ssrCESzWZl',
    gansubFormId: 'oAgLu2Cb5WZSrbjHu',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  ads: { active: true, ...adConfig },
  privacySettings: {
    responsive: {
      cookieVersion: '4',
      cookieUrl: '/info/cookies--i7', // Check the page name before going live with RFE
      privacyUrl: '/info/--i6', // Check the page name before going live with RFE
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '4',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showClassicSwitch: false,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: false },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: {},
};

export default market;
